/* eslint-disable */
import React from "react";
import "./style.scss";
import appLogo from "../../assests/images/smcsLogo.svg";
import { Tag } from "antd";


/**
 * Reusable MCN shipping label component.
 * Accepts structured data via props and renders a print-friendly label.
 */
const MCNLabel = ({
  logoSrc,
  companyName,
  orderId,
  orderDateTime,
  awbNumber,
  topBarcode,
  bottomBarcode,
  referenceNumber,
  mode, // SURFACE / AIR etc
  channel, // ONLINE / OFFLINE etc
  flowType, // Journey Type (e.g., FORWARD / REVERSE)
  weightText, // e.g., "0.1 kgs"
  lbhText, // e.g., "5x5x5 cm"
  colorPatchSrc,
  shipTo,
  shipToAddressLines = [],
  shipToCity,
  shipToState,
  shipToPincode,
  shipToMobile,
  routeCity,
  routePincode,
  shipFromTitle,
  shipFromAddressLines = [],
  shipFromMobile,
  shipFromGst,
  items = [], // [{srNo, product, sku, qty, amount}]
}) => {
  return (
    <div className="mcn-label">
      <div className="mcn-label__header">
        <div className="mcn-label__brand">
          {appLogo ? <img alt="brand" src={appLogo} style={{ width: "25%", height:"25%",margin:"3%" }} /> : null}
          <div className="mcn-label__brand-text">
            <div className="mcn-label__brand-title">SHREE MARUTI INTEGRATED LOGISTICS LIMITED</div>
            <div className="mcn-label__brand-meta">
              <span>Order Date: {orderDateTime || "-"}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Journey Type */}
      {flowType && (
        <div className="mcn-label__journey-type">
          {/* <span className="mcn-label__journey-type-label">Journey Type: </span> */}
          <span className="mcn-label__journey-type-value">{flowType}</span>
        </div>
      )}
      <div className="mcn-label__barcodes-container" style={{display:"flex"}}>
      <div className="mcn-label__barcodes">
        {topBarcode ? (
          <div>
            <img
              src={topBarcode}
              alt="Decoded"
              width="100%"
            />
            <div className="mcn-label__awb">AWB No : {referenceNumber  || "-"}</div>
          </div>
        ) : (
          <p>No barcode found</p>
        )}
        {bottomBarcode ? (
          <div>
            <img
              src={bottomBarcode}
              alt="Decoded"
              width="100%"
            />
            <div className="mcn-label__ref">3PL No : {awbNumber || "-"}</div>
          </div>
        ) : (
          <p>No barcode found</p>
        )}
      </div>
      
      <div className="mcn-label__facts">
        <div className="mcn-label__fact-box">
          <div className="mcn-label__fact-value">{mode || "-"}</div>
        </div>
        <div className="mcn-label__fact-box">
          <div className="mcn-label__fact-value">{channel || "-"}</div>
        </div>
        <div className="mcn-label__fact-box">
          <div className="mcn-label__fact-title">WEIGHT</div>
          <div className="mcn-label__fact-value">{weightText || "-"}</div>
        </div>
        <div className="mcn-label__fact-box">
          <div className="mcn-label__fact-title">LBH</div>
          <div className="mcn-label__fact-value">{lbhText || "-"}</div>
        </div>
      </div>

     
      </div>
      <div className="mcn-label__shipto">
        <div className="mcn-label__section-title">Ship To - {shipTo || "-"}</div>
        <div className="mcn-label__shipto-meta">Mobile number - {shipToMobile || "-"}</div>
        <div className="mcn-label__address">
          {shipToAddressLines.filter(Boolean).map((line, idx) => (
            <div key={`to-${idx}`}>{line}</div>
          ))}
          <div>
            {shipToCity ? `${shipToCity}, ` : ""}
            {shipToState ? `${shipToState}, ` : ""}
            {shipToPincode || ""}
          </div>
        </div>
      </div>  
      <div className="mcn-label__route">
        <div>{routeCity || "-"}</div>
        <div>{routePincode || "-"}</div>
      </div>

      <div className="mcn-label__shipfrom">
        <div className="mcn-label__color-patch">
          {colorPatchSrc ? <img src={colorPatchSrc} alt="color" /> : <span className="mcn-label__color-placeholder" />}
        </div>
        <div className="mcn-label__section-title">{shipFromTitle || "Ship From"} ( If undelivered, return to )
        <div className="mcn-label__from-meta">
          <span>Mobile No: {shipFromMobile || "-"}</span>
          <span>GST No: {shipFromGst || "-"}</span>
        </div>
        </div>
       
        
      </div>
      <div className="mcn-label__address">
          {shipFromAddressLines.filter(Boolean).map((line, idx) => (
            <div key={`from-${idx}`}>{line}</div>
          ))}
        </div>

      <div className="mcn-label__items">
        <table className="mcn-label__table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Product</th>
              <th>SKU</th>
              <th>QTY</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              items.map((it, idx) => (
                <tr key={idx}>
                  <td>{it.srNo ?? idx + 1}</td>
                  <td>{it.product || "-"}</td>
                  <td>{it.sku || "-"}</td>
                  <td>{it.qty || "-"}</td>
                  <td>{it.amount || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No items
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MCNLabel;


